import { promptOf, recordingsOf, said } from "./xiezi-parts.js";

/**
 * What a 词典 entry's drill block says about its character, read once as the
 * reader opens it.
 *
 * `src/cidian-page/cidian-xiezi-markup.ts` writes all five onto the
 * `<details>`, and `xiezi-start.ts` builds the drill from them.
 */

/** The character, where its files are, and what the drill says it with. */
export interface DrillData {
  readonly character: string;
  readonly strokesUrl: string;
  readonly indexUrl: string;

  /** Its reading and meaning, for the stages that hide it. */
  readonly prompt: string | undefined;

  /** Its recordings, one per voice. */
  readonly recordings: readonly string[];
}

/**
 * What the block says about itself.
 * @param block - The `<details>` the markup drew.
 * @returns The character, its files and its cues.
 */
export function drillData(block: HTMLElement): DrillData {
  return {
    character: said(block, "cbCharacter"),
    strokesUrl: said(block, "cbBishun"),
    indexUrl: said(block, "cbHandwriting"),
    prompt: promptOf(block),
    recordings: recordingsOf(block),
  };
}
